module.exports = __webpack_public_path__ + "static/media/grid-item-a8.3f76a7a6.png";